import styled from '@emotion/styled';
import { Button, colors, Stack } from '@ui-components/neo.tax';

export const StyledButton = styled(Button)({
  margin: 0,
  justifyContent: 'space-between',
});

export const StyledStack = styled(Stack)({
  borderTop: `1px solid ${colors.gray[200]}`,
});
